import { render, staticRenderFns } from "./service-ride-header.vue?vue&type=template&id=e815723e&scoped=true"
import script from "./service-ride-header.vue?vue&type=script&lang=js"
export * from "./service-ride-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e815723e",
  null
  
)

export default component.exports